module.exports = __webpack_public_path__ + "img/ic_qrcode_install.2bf9f0e.svg";